import { Box, Container, Text } from '@chakra-ui/react'
import { Page_Swnz_PageFragment } from 'content-service'
import { ReactElement } from 'react'
import { KeepExploringConnect, RichTextRenderer } from 'ui'

interface ResultsPageProps {
  page: Page_Swnz_PageFragment
  disclaimer?: { json: any } | null
  children: ReactElement
}

const ResultsPage = ({ page, disclaimer, children }: ResultsPageProps) => {
  if (page == null || page.content?.__typename !== 'SWNZ_PageSearchResults') {
    return null
  }

  const { keepExploring, promo } = page.content

  return (
    <Box>
      {children}
      {disclaimer && (
        <Container>
          <Box
            marginBottom={14}
            paddingTop={10}
            borderTop="1px solid"
            borderTopColor="deepblue.200"
            dir="ltr"
          >
            <Text fontFamily="enz500">Disclaimer</Text>
            <RichTextRenderer richText={disclaimer} />
          </Box>
        </Container>
      )}
      <KeepExploringConnect
        id={keepExploring?.sys.id || ''}
        typename={keepExploring?.__typename || ''}
      />
    </Box>
  )
}

export default ResultsPage
